module.exports = __webpack_public_path__ + "img/icon1.6d0f1028.png";